import { launchRefusedFailure } from "../../system-modal/failureCopy";
import { BootHttpError } from "../retry/BootHttpError";

/** A refusal's words: a title and a message, no button. */
export interface LaunchRefusalCopy {
  title: string;
  message: string;
}

/**
 * A launch the backend refused for good (decision 81): 401 `launch_unknown` or `launch_expired`, 400
 * `unsupported_currency`. Neither a retry nor a reload helps (a reload opens the same link), so the boot ends on a
 * message with no button: `copy`, the shell's English until the boot has put it in the link's language.
 */
export class LaunchRefusedError extends BootHttpError {
  public constructor(
    public readonly code: string,
    status: number,
    public readonly copy: LaunchRefusalCopy = { title: launchRefusedFailure().titleFallback, message: launchRefusedFailure().messageFallback },
  ) {
    super(`PlaySessionLoader: launch refused (${status} ${code})`, status);
    this.name = "LaunchRefusedError";
  }

  /** The same refusal in other words. */
  public worded(copy: LaunchRefusalCopy): LaunchRefusedError {
    return new LaunchRefusedError(this.code, this.status, copy);
  }
}
